// extracted by mini-css-extract-plugin
module.exports = {"user_profile":"userProfile_user_profile__2Itm1","margin_right":"userProfile_margin_right__27ngA"};